import {ActiveSubstancesColumnsDef} from '@/modules/drug-catalog/substances/components'
import {openActiveSubstanceDrawer} from '@/modules/drug-catalog/substances/components/active-substance-drawer/util'
import {DataTable} from '@cypro/ui/components/ui/data-table'
import {useDrugsCategoryContext} from '@/shared/contexts/drugs-category'
import {useAppForm} from '@cypro/ui/integrations/form'
import {fuzzyFilter} from '@/shared/utils/table'
import {Tabs} from '@chakra-ui/react'
import {DrugCatalogItem} from '@cypro/engine/schema'
import {useStore} from '@tanstack/react-form'
import {getCoreRowModel, getFilteredRowModel, useReactTable} from '@tanstack/react-table'
import {useMemo} from 'react'

export function DrugsTab() {
  // const {t} = useTranslate('common')
  const {category} = useDrugsCategoryContext()

  const form = useAppForm({
    defaultValues: {
      search: '',
    },
  })
  const search = useStore(form.store, state => state.values.search)

  const columns = useMemo(() => {
    return [
      ActiveSubstancesColumnsDef.code({maxSize: 20}),
      ActiveSubstancesColumnsDef.name({maxSize: 42}),
      ActiveSubstancesColumnsDef.doseCalculationMethod({maxSize: 24}),
      ActiveSubstancesColumnsDef.status({maxSize: 14}),
    ]
  }, [])

  const substances = useMemo(() => {
    if (!category.drugCatalogItemsCategories) return []

    const value: DrugCatalogItem[] = []
    for (const {drugCatalogItem} of category.drugCatalogItemsCategories) {
      if (drugCatalogItem) value.push(drugCatalogItem)
    }

    return value
  }, [category])

  const table = useReactTable({
    data: substances,
    columns,
    filterFns: {
      fuzzy: fuzzyFilter(),
    },
    globalFilterFn: 'fuzzy',
    state: {
      globalFilter: search,
    },
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
  })

  return (
    <Tabs.Content value="substances" spaceY="8" display="flex" flexDirection="column">
      <form onSubmit={e => e.preventDefault()}>
        <form.AppForm>
          <form.AppField name="search">{field => <field.Searchbox maxWidth="100%" />}</form.AppField>
        </form.AppForm>
      </form>

      <DataTable table={table} onRowClick={openActiveSubstanceDrawer} />
    </Tabs.Content>
  )
}
